export default __webpack_public_path__ + "static/media/landlords.4fecc9d8.png";